var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetricFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1405,
    height: 636,
    viewBox: "0 0 1405 636",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M884.474 207.491L883.998 206.336L884.984 205.453C885.256 206.234 885.086 206.914 884.474 207.491Z",
    fill: "#16497A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M775.735 531.035C775.327 532.088 774.715 532.972 773.866 533.719C774.478 532.802 775.089 531.918 775.735 531.035Z",
    fill: "#1462AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.35 626.896C931.808 627.135 863.296 626.896 794.886 626.828L794.92 626.794H795.022C795.566 626.111 796.144 625.461 796.722 624.778C797.3 624.095 797.878 623.446 798.456 622.763C816.817 613.744 820.251 604.486 814.743 578.624C804.576 547.81 794.376 517.029 784.21 486.214C774.349 458.645 764.455 431.041 754.561 403.438C753.847 400.226 753.167 397.049 752.487 393.838C743.068 365.346 731.384 338.492 722 310C716.084 294.046 716.416 282.488 710.5 266.5C702.914 246 699.99 237.714 696.726 226.372C686.9 196.992 677.108 167.578 667.282 138.198C665.479 133.483 663.541 128.769 661.875 124.02C647.527 82.8543 633.178 41.7223 619 1.00024H815.119C827.502 1.00024 838.579 8.62395 843.224 20.1029C844.207 22.532 845.177 24.8989 846.057 26.9981C854.592 47.1542 859.862 68.6767 866.492 89.6527C868.77 96.3827 871.082 103.113 873.36 109.843C875.128 114.557 876.862 119.306 878.631 124.055C879.141 126.241 879.651 128.427 880.161 130.614C881.929 135.26 883.697 139.906 885.465 144.552C885.941 146.704 886.451 148.857 886.927 151.009C894.441 172.771 901.955 194.567 909.469 216.362C910.524 219.744 911.612 223.161 912.7 226.577C914.162 231.052 915.59 235.562 917.052 240.037C925.042 263.951 933.032 287.899 941.022 311.813C953.535 349.29 966.013 386.8 978.526 424.277C984.272 441.427 989.984 458.542 995.696 475.658C996.172 476.717 996.614 477.776 997.056 478.835C997.736 481.158 998.382 483.515 999.062 485.838C1010.59 519.591 1023 553.105 1033.37 587.233C1040.14 609.61 1025.21 626.76 1000.35 626.896Z",
    fill: "url(#paint0_linear_506_61)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M656.007 405.595L628.713 496.216C602.284 514.938 587.467 525.437 561.038 544.159C561.038 544.159 497 408.279 497 404.983C497 401.687 618.958 341.172 618.958 341.172L656.007 405.595Z",
    fill: "url(#paint1_linear_506_61)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M699.607 223.778C702.871 234.986 704.771 243.357 708 254.565C703.887 261.756 697.024 278.94 697.024 278.94L695.732 281.202L693.318 288.224C693.318 288.224 671.818 353.214 671.24 355.408C670.628 357.029 689.681 299.6 689.681 299.6L686.792 308.513L685.058 314.825L682.542 321.847C682.542 321.847 679.687 328.43 678.667 331.874C677.647 335.317 676.662 338.727 675.642 342.136C675.642 342.136 677.919 335.317 675.676 342.102C673.432 348.888 668.877 362.459 668.877 362.459C668.911 362.425 668.911 362.425 668.945 362.391C667.721 365.733 666.497 369.076 665.274 372.418C664.73 374.612 664.22 376.84 663.71 379.034C663.132 380.283 662.554 381.532 662.01 382.815C660.956 388.318 659.903 393.821 658.883 399.357C658.883 399.357 658.917 399.526 658.917 399.728C658.951 400.032 658.985 400.336 658.951 400.336C630.702 400.066 602.487 400.1 574.273 399.391C561.933 399.053 556.562 404.556 556.358 416.203C558.534 419.984 559.927 424.575 562.953 427.41C585.661 448.577 608.708 469.406 631.654 490.37C624.889 505.021 617.445 519.437 611.496 534.425C602.725 556.436 595.043 578.852 586.918 601.099C583.213 604.711 579.542 608.289 575.836 611.901L574.681 612.34C571.961 613.117 569.276 613.893 566.557 614.703C538.614 615.379 510.705 616.527 482.762 616.662C458.728 616.763 435.006 621.469 410.972 620.962C385.035 618.194 373.643 596.541 381.393 572.539C386.628 556.2 392.679 540.164 398.356 523.994C401.468 516.495 401.468 516.495 401.468 516.495C401.468 516.495 400.803 518.863 401.109 517.614C405.427 504.144 409.778 490.708 414.095 477.238C415.285 473.93 416.44 470.655 417.63 467.381L417.732 467.144C418.616 464.781 419.5 462.384 420.418 460.021C421.777 455.801 423.171 451.548 424.565 447.362C424.973 446.146 425.415 444.965 425.857 443.75C426.333 442.433 426.842 441.116 427.318 439.8C427.42 438.753 427.659 437.774 428.033 436.829C430.208 430.111 432.383 423.393 434.559 416.675L434.627 416.506C436.735 410.767 438.842 405.028 440.95 399.289C441.052 398.277 441.29 397.298 441.664 396.352C442.819 393.179 443.975 389.972 445.131 386.799C445.641 385.516 446.185 384.267 446.729 382.984C447.137 381.769 447.545 380.553 447.953 379.372L447.987 379.271C450.23 371.405 452.508 363.539 454.751 355.673C456.893 349.934 459.034 344.195 461.142 338.457C463.488 331.772 465.867 325.088 468.213 318.404C468.281 317.357 468.587 316.345 469.097 315.433C479.737 284.814 490.411 254.161 501.051 223.542C501.153 222.428 501.492 221.415 502.002 220.436C503.362 216.217 504.756 212.03 506.116 207.811C507.067 205.177 508.02 202.511 508.971 199.844C509.583 199.27 509.753 198.595 509.481 197.818C510.229 195.489 510.977 193.126 511.758 190.796C517.435 174.558 523.112 158.354 528.823 142.15C529.673 138.943 530.523 135.736 531.339 132.529C532.053 130.807 532.767 129.086 533.48 127.364L533.99 126.419C541.673 103.8 549.355 81.1821 557.038 58.5638C557.684 56.3358 558.364 54.1077 559.01 51.9134C562.783 40.2329 565.536 28.1474 570.499 17.007C577.876 0.634123 578.148 1.17439 593.785 1.07312C617.991 1.54366 568.358 0.696173 622 1C636.175 41.2402 650.418 81.9585 664.764 122.638C666.429 127.33 668.367 131.989 670.169 136.648C679.993 165.68 689.783 194.712 699.607 223.778Z",
    fill: "url(#paint2_linear_506_61)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M572.846 618.801L572.439 619.685L571.69 619.243L572.846 618.801Z",
    fill: "#1462AC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M655.957 405.892C655.991 405.892 655.957 405.586 655.923 405.28L655.99 405.892H655.957Z",
    fill: "#105DA6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M655.957 405.892C655.991 405.892 655.957 405.586 655.923 405.28L655.99 405.892H655.957Z",
    fill: "#1C6BB1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M579 622.172L638.5 448L701 254.5L703.5 263L780.5 497.172",
    stroke: "#F5F5F5",
    strokeWidth: 14
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1403.24 587.071C1392.87 553.127 1380.47 519.794 1368.94 486.223C1368.26 483.913 1367.62 481.568 1366.94 479.257C1366.5 478.204 1366.06 477.151 1365.58 476.097C1359.87 459.074 1354.16 442.051 1348.41 424.994C1335.91 387.719 1323.43 350.411 1310.92 313.137C1302.94 289.352 1294.95 265.533 1286.96 241.748C1285.5 237.297 1284.07 232.811 1282.61 228.36C1281.52 224.962 1280.43 221.565 1279.38 218.201C1271.87 196.522 1264.36 174.844 1256.84 153.2C1256.37 151.059 1255.86 148.919 1255.38 146.778C1253.62 142.157 1251.85 137.536 1250.08 132.915C1249.57 130.74 1249.06 128.565 1248.55 126.391C1246.78 121.668 1245.05 116.945 1243.28 112.256C1241 105.562 1238.69 98.8682 1236.42 92.1745C1229.79 71.3117 1224.52 49.9052 1215.99 29.8579C1213.46 23.8475 1208.74 18.7722 1203.76 13.8013C1197.61 7.66552 1189.25 4.00024 1180.56 4.00024H989C1003.17 44.5026 1017.52 85.4127 1031.86 126.357C1033.53 131.08 1035.46 135.769 1037.27 140.458C1047.09 169.679 1056.88 198.935 1066.7 228.156C1069.97 239.437 1073.23 250.752 1076.46 262.033C1082.37 277.935 1088.32 293.803 1094.23 309.671C1103.62 338.009 1113.03 366.381 1122.45 394.719C1123.13 397.913 1123.81 401.073 1124.52 404.267C1134.41 431.722 1144.3 459.176 1154.16 486.597C1164.32 517.245 1174.52 547.86 1184.68 578.509C1190.19 604.23 1186.76 613.439 1168.4 622.409C1167.82 623.088 1167.25 623.734 1166.67 624.414C1166.09 625.093 1165.51 625.739 1164.97 626.418H1164.87L1164.83 626.452C1233.22 626.52 1301.71 626.758 1370.24 626.52C1395.08 626.384 1410 609.327 1403.24 587.071Z",
    fill: "url(#paint3_linear_506_61)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1192.32 204.491L1191.84 203.336L1192.83 202.453C1193.1 203.234 1192.93 203.914 1192.32 204.491Z",
    fill: "#16497A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M505.474 204.491L504.998 203.336L505.984 202.453C506.256 203.234 506.086 203.914 505.474 204.491Z",
    fill: "#16497A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M655.439 406.29C655.473 406.29 655.439 405.984 655.405 405.678L655.473 406.29H655.439Z",
    fill: "#105DA6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M655.439 406.29C655.473 406.29 655.439 405.984 655.405 405.678L655.473 406.29H655.439Z",
    fill: "#1C6BB1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M621.354 621.897C552.808 622.134 484.296 621.897 415.886 621.829L415.92 621.795H415C415.544 621.118 417.722 619.796 417.722 619.796L420.5 618C420.5 618 441.5 608.5 435.743 574.011C429.985 539.521 415.376 512.907 405.21 482.339C395.349 454.989 385.455 427.606 375.561 400.223C374.847 397.038 374.167 393.886 373.487 390.7C364.068 362.436 354.65 334.138 345.266 305.874C339.349 290.047 333.401 274.221 327.484 258.36C324.254 247.109 320.99 235.823 317.726 224.572C307.9 195.427 298.108 166.247 288.282 137.102C286.479 132.425 284.541 127.749 282.875 123.038C268.527 82.2005 254.178 41.3971 240 1.00024H436.179C448.532 1.00024 459.588 8.58847 464.255 20.0264C465.228 22.4094 466.187 24.73 467.057 26.7905C475.592 46.7855 480.862 68.1362 487.492 88.9446C489.77 95.6209 492.082 102.297 494.36 108.974C496.128 113.65 497.862 118.361 499.631 123.072C500.141 125.241 500.651 127.41 501.161 129.579C502.929 134.188 504.697 138.797 506.465 143.406C506.941 145.541 507.451 147.676 507.927 149.811C515.441 171.399 522.955 193.02 530.469 214.642C531.524 217.997 532.612 221.386 533.7 224.775C535.162 229.215 536.59 233.688 538.052 238.128C546.042 261.851 554.032 285.608 562.022 309.331C574.535 346.508 587.013 383.719 599.526 420.896C605.272 437.909 610.984 454.888 616.696 471.867C617.172 472.917 617.614 473.968 618.056 475.018C618.736 477.323 619.382 479.661 620.062 481.966C631.589 515.449 643.999 548.695 654.369 582.551C661.136 604.749 646.209 621.762 621.354 621.897Z",
    fill: "url(#paint4_linear_506_61)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M277.007 402.595L249.713 493.216C223.284 511.938 208.467 522.437 182.038 541.159C182.038 541.159 118 405.279 118 401.983C118 398.687 239.958 338.172 239.958 338.172L277.007 402.595Z",
    fill: "url(#paint5_linear_506_61)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M320.608 225.23C323.871 236.51 325.771 244.936 329 256.217C324.887 263.454 318.025 280.75 318.025 280.75L316.733 283.027L314.32 290.095C314.32 290.095 292.821 355.508 292.243 357.717C291.631 359.348 310.683 301.545 310.683 301.545L307.794 310.516L306.06 316.87L303.545 323.937C303.545 323.937 300.69 330.563 299.67 334.029C298.65 337.495 297.664 340.926 296.645 344.358C296.645 344.358 298.922 337.495 296.679 344.324C294.435 351.154 289.881 364.813 289.881 364.813C289.915 364.779 289.915 364.779 289.949 364.745C288.725 368.109 287.501 371.473 286.278 374.837C285.734 377.046 285.224 379.288 284.714 381.497C284.136 382.754 283.558 384.011 283.015 385.302C281.961 390.841 280.907 396.379 279.887 401.952C279.887 401.952 279.921 402.122 279.921 402.326C279.955 402.631 279.989 402.937 279.955 402.937C251.709 402.665 223.497 402.699 195.285 401.986C182.947 401.646 177.577 407.184 177.373 418.907C179.548 422.713 180.941 427.334 183.967 430.188C206.672 451.492 229.718 472.457 252.661 493.558C245.897 508.304 238.453 522.813 232.505 537.9C223.735 560.054 216.054 582.615 207.93 605.007C204.225 608.643 200.554 612.245 196.849 615.88L195.693 616.322C192.974 617.104 190.289 617.885 187.57 618.701C159.63 619.38 131.723 620.536 103.783 620.671C79.7521 620.773 55.7549 619.754 31.7237 619.244C5.78906 616.458 -5.32576 600.42 2.42405 576.262C7.65857 559.816 13.7088 543.676 19.3852 527.4C20.235 526.653 20.8468 525.769 21.2547 524.716C21.5606 523.459 21.8325 522.236 22.1384 520.978C26.4552 507.421 30.806 493.898 35.1227 480.34C36.3124 477.01 37.4681 473.714 38.6577 470.418L38.7597 470.181C39.6435 467.802 40.5272 465.39 41.4449 463.011C42.8046 458.764 44.1982 454.482 45.5918 450.269C45.9996 449.046 46.4415 447.857 46.8834 446.633C47.3593 445.308 47.8691 443.983 48.345 442.658C48.447 441.605 48.6852 440.619 49.0591 439.668C51.2345 432.906 53.4096 426.144 55.5849 419.383L55.6529 419.213C57.7603 413.436 59.8677 407.66 61.9751 401.884C62.0771 400.864 62.315 399.879 62.6889 398.928C63.8446 395.734 65.0003 392.506 66.1559 389.312C66.6658 388.021 67.21 386.763 67.7535 385.472C68.1617 384.249 68.5693 383.026 68.9771 381.836L69.0111 381.735C71.2545 373.818 73.5319 365.901 75.7752 357.984C77.9166 352.207 80.058 346.431 82.1654 340.655C84.5108 333.927 86.8901 327.199 89.2354 320.471C89.3034 319.418 89.6093 318.399 90.1192 317.481C100.758 286.663 111.431 255.81 122.07 224.992C122.172 223.87 122.512 222.851 123.022 221.866C124.381 217.618 125.775 213.405 127.135 209.158C128.086 206.507 129.038 203.823 129.99 201.139C130.602 200.561 130.772 199.882 130.5 199.1C131.248 196.756 131.995 194.377 132.777 192.033C138.453 175.689 144.13 159.379 149.84 143.07C150.69 139.842 151.54 136.614 152.356 133.386C153.069 131.653 153.783 129.92 154.497 128.187L155.007 127.236C162.689 104.47 170.37 81.7044 178.052 58.9388C178.698 56.6962 179.378 54.4537 180.024 52.2451C183.797 40.4885 186.55 28.3242 191.512 17.1113C198.888 0.631784 199.16 1.17557 214.796 1.07363C239 1.54724 193.863 0.767818 247.5 1.07362L242.906 1.07349C257.08 41.5758 271.424 82.4859 285.768 123.43C287.433 128.153 289.371 132.842 291.172 137.531C300.996 166.753 310.785 195.974 320.608 225.23Z",
    fill: "url(#paint6_linear_506_61)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M193.846 615.801L193.439 616.685L192.69 616.243L193.846 615.801Z",
    fill: "#1462AC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M276.957 402.892C276.991 402.892 276.957 402.586 276.923 402.28L276.99 402.892H276.957Z",
    fill: "#105DA6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M276.957 402.892C276.991 402.892 276.957 402.586 276.923 402.28L276.99 402.892H276.957Z",
    fill: "#1C6BB1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M200 619.172L262 457.172L321.5 292.672L327 275.172L401.5 494.172",
    stroke: "#F5F5F5",
    strokeWidth: 14
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M632.5 503.172L701.5 263.672L804.5 572.172",
    stroke: "#F5F5F5",
    strokeWidth: 14
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M984 4.17163L1177.5 579.172",
    stroke: "#F5F5F5",
    strokeWidth: 14
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M411 628L647 629",
    stroke: "#F5F5F5",
    strokeWidth: 14
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M403 491L371 577",
    stroke: "#F5F5F5",
    strokeWidth: 14
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M569.5 3L519 148.5",
    stroke: "#F5F5F5",
    strokeWidth: 14
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_506_61",
    x1: 618.992,
    y1: 313.983,
    x2: 1034.99,
    y2: 313.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#865CA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4837F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_506_61",
    x1: 441.606,
    y1: 392.911,
    x2: 1163.47,
    y2: 635.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#542F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0535,
    stopColor: "#563292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1112,
    stopColor: "#5A3C97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    stopColor: "#614A9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2312,
    stopColor: "#6A5CA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2685,
    stopColor: "#726AB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2876,
    stopColor: "#726AB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5197,
    stopColor: "#726AB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7266,
    stopColor: "#865CA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4837F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_506_61",
    x1: 486.133,
    y1: 264.59,
    x2: 1207.09,
    y2: 508.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#542F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0535,
    stopColor: "#563292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1112,
    stopColor: "#5A3C97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    stopColor: "#614A9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2312,
    stopColor: "#6A5CA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2685,
    stopColor: "#726AB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2876,
    stopColor: "#726AB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5197,
    stopColor: "#726AB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7266,
    stopColor: "#865CA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4837F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_506_61",
    x1: 1108.88,
    y1: -34.8715,
    x2: 1289.02,
    y2: 647.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#865CA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4837F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_506_61",
    x1: 239.992,
    y1: 311.483,
    x2: 655.995,
    y2: 311.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#865CA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4837F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_506_61",
    x1: 62.6062,
    y1: 389.911,
    x2: 784.465,
    y2: 632.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#542F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0535,
    stopColor: "#563292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1112,
    stopColor: "#5A3C97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    stopColor: "#614A9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2312,
    stopColor: "#6A5CA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2685,
    stopColor: "#726AB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2876,
    stopColor: "#726AB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5197,
    stopColor: "#726AB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7266,
    stopColor: "#865CA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4837F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_506_61",
    x1: 107.154,
    y1: 266.307,
    x2: 829.013,
    y2: 508.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#542F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0535,
    stopColor: "#563292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1112,
    stopColor: "#5A3C97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    stopColor: "#614A9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2312,
    stopColor: "#6A5CA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2685,
    stopColor: "#726AB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2876,
    stopColor: "#726AB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5197,
    stopColor: "#726AB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7266,
    stopColor: "#865CA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4837F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricFavicon);
export default __webpack_public_path__ + "static/media/metric-favicon.c4322445cde681864c4cb0158c229df2.svg";
export { ForwardRef as ReactComponent };